/**
 * Espera antes de voltar a ligar o tempo real: exponencial, com teto e com jitter (ADR-0017).
 *
 * O jitter é o que evita a tempestade de reconexões quando o servidor reinicia numa entrega e fecha todas as ligações
 * ao mesmo tempo (código 1012): cada separador volta num instante diferente.
 */

const BACKOFF_BASE_MS = 500;
export const BACKOFF_MAX_MS = 30_000;
/** Ao fim de tantas tentativas falhadas, a app passa a consultar por cursor enquanto continua a tentar. */
export const FALLBACK_AFTER_ATTEMPTS = 4;

/** `attempt` começa em 0. `random` em [0, 1) (injetável nos testes). */
export function reconnectDelay(attempt: number, random: () => number = Math.random): number {
  const ceiling = Math.min(BACKOFF_MAX_MS, BACKOFF_BASE_MS * 2 ** Math.max(0, attempt));
  // «Full jitter»: um valor ao acaso entre metade e o teto.
  return Math.round(ceiling / 2 + random() * (ceiling / 2));
}

/** O servidor a reiniciar (1012) volta depressa: a primeira tentativa é já, com jitter curto. */
export function delayAfterClose(code: number, attempt: number, random: () => number = Math.random): number {
  if (code === 1012 && attempt === 0) return Math.round(random() * 1500);
  return reconnectDelay(attempt, random);
}
